"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _streamChatReact = require("stream-chat-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var formatSeparatorDate = function formatSeparatorDate(date, formatDate) {
  return formatDate ? formatDate(date) : (0, _streamChatReact.isDayOrMoment)(date) ? date.calendar(null, {
    // the format 'Do' doesn’t work for custom calendar() formatting, so we can’t do 1st, 12th, etc. :(
    lastWeek: 'dddd, MMMM D, YYYY',
    sameElse: 'MMMM D, YYYY' // further in the past (beyond last week)
  }) : date;
};

// Custom DateSeparator component, partially copied from corresponding GetStream component to be compatible
var DateSeparator = function DateSeparator(props) {
  var date = props.date,
    formatDate = props.formatDate,
    formatTitleDate = props.formatTitleDate,
    _props$position = props.position,
    position = _props$position === void 0 ? 'right' : _props$position,
    unread = props.unread;
  var _useTranslationContex = (0, _streamChatReact.useTranslationContext)(),
    t = _useTranslationContex.t,
    tDateTimeParser = _useTranslationContex.tDateTimeParser;
  if (typeof date === 'string') {
    return null;
  }
  var parsedDate = tDateTimeParser(date.toISOString());
  var formattedDate = formatSeparatorDate(parsedDate, formatDate);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__date-separator"
  }, (position === 'right' || position === 'center') && /*#__PURE__*/_react.default.createElement("hr", {
    className: "str-chat__date-separator-line"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__date-separator-date cursor-pointer",
    title: formatSeparatorDate(date, formatTitleDate)
  }, unread ? "".concat(t('New'), " - ").concat(formattedDate) : formattedDate), (position === 'left' || position === 'center') && /*#__PURE__*/_react.default.createElement("hr", {
    className: "str-chat__date-separator-line"
  }));
};
var _default = DateSeparator;
exports.default = _default;